import React from 'react';
import PropTypes from 'prop-types';
import {action} from 'mobx';
import {inject, observer} from 'mobx-react';
import {withRouter} from 'react-router';
import autobind from 'autobind-decorator';

import {withConfig, withI18n} from 'spa/Components/Context';
import {RadioOption} from 'spa/Components/Form';

import {PAYMENT_TYPES} from '../../state/payments/billing';

import {cn} from 'spa/css';
import '../CheckoutPaymentDetails/checkout-payment-details.less';

@withRouter
@inject(({
  store: {
    billing,
    notifications,
    session,
  },
}) =>
  ({
    billing,
    notifications,
    session,
  }))
@observer
@withConfig
@withI18n
class PaymentOptions extends React.Component {
  static propTypes = {
    canMakeApplePayments: PropTypes.bool,
    canUseApplePay: PropTypes.bool,
    canUsePaypal: PropTypes.bool,
    disabled: PropTypes.bool,
    onChangeOption: PropTypes.func.isRequired,
    paymentInfo: PropTypes.shape({
      paymentOption: PropTypes.string,
      paymentToken: PropTypes.string,
    }).isRequired,
    session: PropTypes.shape({
      user: PropTypes.object,
    }).isRequired,
  };

  static defaultProps = {
    canMakeApplePayments: false,
    canUseApplePay: false,
    canUsePaypal: false,
    disabled: false,
  };

  @autobind
  @action('onChangeOption - PaymentOptions')
  onChangeOption(event) {
    const {onChangeOption} = this.props;

    onChangeOption(event);
  }

  render() {
    const {i18n} = this.context;
    const {
      canMakeApplePayments,
      canUseApplePay,
      canUsePaypal,
      disabled,
      paymentInfo,
    } = this.props;
    const {
      onChangeOption,
    } = this;

    return (
      <div className="checkout-payment-details__option-container">
        <RadioOption
          className={cn(
            'checkout-payment-details__checkout-payment-option',
            'checkout-payment-details__checkout-payment-option--card',
            disabled && 'checkout-payment-details__checkout-payment-option--disabled',
            canUseApplePay && canMakeApplePayments && 'checkout-payment-details__checkout-payment-option--apple-pay-active',
          )}
          label={i18n._x('Card', 'Gifts Checkout Payment Details')}
          name="payment-option"
          value={PAYMENT_TYPES.CARD}
          onChange={onChangeOption}
          checked={paymentInfo.paymentOption === PAYMENT_TYPES.CARD}
          disabled={disabled}
        />
        {canUsePaypal &&
          <RadioOption
            className={cn(
              'checkout-payment-details__checkout-payment-option',
              'checkout-payment-details__checkout-payment-option--paypal',
              disabled && 'checkout-payment-details__checkout-payment-option--disabled',
              canUseApplePay && canMakeApplePayments && 'checkout-payment-details__checkout-payment-option--apple-pay-active',
            )}
            label={i18n._x('PayPal', 'Gifts Checkout Payment Details')}
            name="payment-option"
            value={PAYMENT_TYPES.PAYPAL}
            onChange={onChangeOption}
            checked={paymentInfo.paymentOption === PAYMENT_TYPES.PAYPAL}
            disabled={disabled}
          />
        }
        {canMakeApplePayments && canUseApplePay &&
          <RadioOption
            className={cn(
              'checkout-payment-details__checkout-payment-option',
              'checkout-payment-details__checkout-payment-option--apple-pay',
              disabled && 'checkout-payment-details__checkout-payment-option--disabled',

            )}
            label={i18n._x('Apple Pay', 'Checkout apple pay')}
            name="payment-option"
            value={PAYMENT_TYPES.APPLE_PAY}
            onChange={onChangeOption}
            checked={paymentInfo.paymentOption === PAYMENT_TYPES.APPLE_PAY}
            disabled={disabled}
          />
        }
      </div>
    );
  }
}

export default PaymentOptions;



// WEBPACK FOOTER //
// ./spa/Components/AddPaymentMethod/PaymentOptions.jsx